import * as React from "react";
import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
  MessageBarIntent,
} from "@fluentui/react-components";

interface ErrorBarProps {
  title?: string;
  message: string | null;
  intent?: MessageBarIntent;
}

/** Bandeau d'erreur/warning Fluent UI, masqué si message vide. */
export function ErrorBar({ title, message, intent = "error" }: ErrorBarProps): React.ReactElement | null {
  if (!message) return null;
  return (
    <MessageBar intent={intent} style={{ marginBottom: 8 }}>
      <MessageBarBody style={{ whiteSpace: "pre-wrap" }}>
        {title && <MessageBarTitle>{title}</MessageBarTitle>} {message}
      </MessageBarBody>
    </MessageBar>
  );
}
